const STATE_CLASS_NAME = 'State';
const precompileStateClass = ({ graph, settings, variableNamesReadOnly, variableNamesAssigner, precompiledCodeAssigner, }, nodeType) => {
    const precompiledImplementation = precompiledCodeAssigner.nodeImplementations[nodeType];
    if (precompiledImplementation.nodeImplementation.state) {
        const sampleNode = Object.values(graph).find((node) => node.type === nodeType);
        if (!sampleNode) {
            throw new Error(`No node of type "${nodeType}" exists in the graph.`);
        }
        // Ensure the class name exists in the namespace.
        _getNamespace(nodeType, variableNamesAssigner)[STATE_CLASS_NAME];
        const astClass = precompiledImplementation.nodeImplementation.state({
            ns: _getNamespace(nodeType, variableNamesReadOnly),
            node: sampleNode,
        }, variableNamesReadOnly.globals, settings);
        precompiledImplementation.stateClass = {
            ...astClass,
            // Reset member values since they are irrelevant for the state class declaration.
            members: astClass.members.map((member) => ({
                ...member,
                value: undefined,
            })),
        };
    }
};
const precompileCore = ({ settings, variableNamesReadOnly, variableNamesAssigner, precompiledCodeAssigner, }, nodeType) => {
    const precompiledImplementation = precompiledCodeAssigner.nodeImplementations[nodeType];
    const nodeImplementation = precompiledImplementation.nodeImplementation;
    if (nodeImplementation.core) {
        precompiledImplementation.core = nodeImplementation.core({
            ns: _getNamespace(nodeType, variableNamesAssigner),
        }, variableNamesReadOnly.globals, settings);
    }
};
const _getNamespace = (nodeType, variableNamesIndex) => variableNamesIndex.nodeImplementations[nodeType];

export { STATE_CLASS_NAME, precompileCore, precompileStateClass };
